/** Origins of the other HLT apps and the API, compiled in at build time (local ports in development). */
const env = import.meta.env;
const pick = (value: string | undefined, development: string, production: string): string =>
    value ?? (env.MODE === 'development' ? development : production);

export const origins = {
    platform: pick(env.VITE_PLATFORM_ORIGIN, 'http://localhost:5173', 'https://app.hlt.cloud'),
    fiveS: pick(env.VITE_FIVE_S_ORIGIN, 'http://localhost:5174', 'https://5s.hlt.cloud'),
    site: pick(env.VITE_SITE_ORIGIN, 'http://localhost:5175', 'https://hlt.cloud'),
    /** Empty in development: Vite proxies `/api` on this origin. */
    api: pick(env.VITE_API_ORIGIN, '', 'https://api.hlt.cloud'),
};
